// @flow
import React, { Component } from 'react'

import EnterpriseButton from './index'
// $FlowFixMe
export default class extends Component {
  static displayName: any = 'WAAD Form'

  render (): any {
    return (
      <EnterpriseButton classes='login__button--ms' {...this.props}>
        <i className='icon icon--ms' />
        Sign In with Azure AD
      </EnterpriseButton>
    )
  }
}
